<template>
	<main class="mnt-main">
		<section class="mnt-hero">
			<div class="mnt-container mnt-hero__inner">
				<h1 class="mnt-hero__title">Exchange Platform Is Currently Unavailable</h1>
				<p class="mnt-hero__text">
					Following the expiry of its previous authorisation, {{ subject }} is currently
					not providing crypto-asset services. Registration, login, onboarding, deposits,
					withdrawals, transfers, exchange and all other transactional functionality are
					unavailable. Services will remain unavailable unless and until the required MiCA
					authorisation has been granted.
				</p>
				<p class="mnt-hero__text">
					This website is maintained for informational and client-support purposes only.
				</p>
				<a v-if="supportMailto" class="mnt-button" :href="supportMailto">Contact Support</a>
			</div>
		</section>

		<section class="mnt-section">
			<div class="mnt-container mnt-cards">
				<div v-for="card in cards" :key="card.title" class="mnt-card">
					<MaintenanceIcon :name="card.icon" class="mnt-card__icon" />
					<h2 class="mnt-card__title">{{ card.title }}</h2>
					<p class="mnt-card__text">{{ card.text }}</p>
				</div>
			</div>
		</section>

		<section class="mnt-section">
			<div class="mnt-container mnt-panel mnt-panel_split">
				<div class="mnt-status">
					<h2 class="mnt-panel__title">Current Service Status</h2>
					<ul class="mnt-status__list">
						<li v-for="service in services" :key="service.title" class="mnt-status__row">
							<MaintenanceIcon :name="service.icon" class="mnt-status__icon" />
							<span class="mnt-status__name">{{ service.title }}</span>
							<span class="mnt-badge">
								<MaintenanceIcon name="x-circle" class="mnt-badge__icon" />
								Unavailable
							</span>
						</li>
					</ul>
				</div>
				<aside class="mnt-assist">
					<div class="mnt-assist__head">
						<MaintenanceIcon name="question" class="mnt-assist__icon" />
						<h2 class="mnt-panel__title">Need assistance?</h2>
					</div>
					<p class="mnt-assist__text">
						If you are an existing or former client, please contact us regarding account
						history, complaints, the safeguarding, return or transfer of assets, or other
						support matters.
					</p>
					<template v-if="supportMailto">
						<a class="mnt-link mnt-assist__email" :href="supportMailto">{{ info.supportEmail }}</a>
						<a class="mnt-button" :href="supportMailto">Email Support</a>
					</template>
				</aside>
			</div>
		</section>

		<section class="mnt-section">
			<div class="mnt-container mnt-panel mnt-regulatory">
				<div class="mnt-regulatory__head">
					<MaintenanceIcon name="scales" class="mnt-regulatory__icon" />
					<div>
						<h2 class="mnt-panel__title">Regulatory status</h2>
						<p class="mnt-regulatory__text">
							{{ subjectSentenceStart }} is currently not authorised to provide crypto-asset services.
						</p>
						<p class="mnt-regulatory__text">
							A MiCA authorisation application is under review by the competent authority.
						</p>
					</div>
				</div>
				<ul class="mnt-regulatory__facts">
					<li v-for="fact in facts" :key="fact.title" class="mnt-regulatory__fact">
						<MaintenanceIcon :name="fact.icon" class="mnt-regulatory__fact-icon" />
						<span class="mnt-regulatory__fact-title">{{ fact.title }}</span>
					</li>
				</ul>
			</div>
		</section>
	</main>
</template>

<script>
import MaintenanceIcon from '../components/MaintenanceIcon.vue';

export default {
	name: 'Maintenance',
	components: { MaintenanceIcon },
	data() {
		return {
			cards: [
				{
					icon: 'info',
					title: 'Informational only',
					text: 'This page is provided for regulatory, informational and support purposes only.',
				},
				{
					icon: 'user',
					title: 'No new onboarding',
					text: 'No new clients are accepted and no new accounts may be opened.',
				},
				{
					icon: 'headset',
					title: 'Client support',
					text: 'Existing or former clients may contact support regarding account history, complaints, or wind-down matters.',
				},
			],
			services: [
				{ icon: 'user-x', title: 'Registration' },
				{ icon: 'lock', title: 'Login' },
				{ icon: 'exchange', title: 'Buy / Sell / Exchange' },
				{ icon: 'bank', title: 'Deposits / Withdrawals / Transfers' },
			],
			facts: [
				{ icon: 'megaphone', title: 'No marketing of services' },
				{ icon: 'user-x', title: 'No new accounts' },
				{ icon: 'document', title: 'MiCA application under review' },
			],
		};
	},
	computed: {
		info() {
			return this.$parent.maintenanceInfo;
		},
		subject() {
			return this.info.companyName || 'the platform';
		},
		subjectSentenceStart() {
			return this.info.companyName || 'The platform';
		},
		supportMailto() {
			return this.info.supportEmail ? 'mailto:' + this.info.supportEmail : '';
		},
	},
	mounted() {
		document.title = 'Daxchain — Services Unavailable';
	},
};
</script>
